module.exports = __webpack_public_path__ + "img/video.4b3187e2.jpg";